export const SUBSCRIPTION_MIN_AMOUNT = 3
export const SUBSCRIPTION_MAX_AMOUNT = 20

export const YEARLY_SUBSCRIPTION_FEE = 200
export const MONTHLY_SUBSCRIPTION_FEE = 20

export const DEFAULT_AMOUNT = 3
